class IconsSet {
    public static $inject = ["$mdIconProvider", "iconsRegistry"];

    constructor($mdIconProvider, iconsRegistry) {
        angular.forEach(iconsRegistry, icon => {
            $mdIconProvider.icon(icon.id, icon.url, icon.size);
        });
    }
}

class IconsCache {
    public static $inject = ["$templateRequest", "iconsRegistry"];

    constructor($templateRequest, iconsRegistry) {
        angular.forEach(iconsRegistry, icon => {
            $templateRequest(icon.url);
        });
    }
}

angular
    .module("thor.icons", [])
    .constant("iconsRegistry", [
        { id: "logo-auction", url: require("../../../assets/icons/logo-auction.svg"), size: 24 },
        { id: "logo-auction-full", url: require("../../../assets/icons/logo-auction-full.svg"), size: 24 },
        { id: "logo-auction-blue", url: require("../../../assets/icons/logo-auction-blue.svg"), size: 24 },
        { id: "logo-auction-white", url: require("../../../assets/icons/logo-auction-white.svg"), size: 24 },
        { id: "logo-ie", url: require("../../../assets/icons/logo-ie.svg"), size: 24 },
        { id: "logo-ie-full", url: require("../../../assets/icons/logo-ie-full.svg"), size: 24 },
        { id: "logo-ie-white", url: require("../../../assets/icons/logo-ie-white.svg"), size: 24 },
        { id: "logo-temis", url: require("../../../assets/icons/logo-temis.svg"), size: 24 },
        { id: "logo-tpk", url: require("../../../assets/icons/logo-tpk.svg"), size: 24 },
        { id: "logo-cocolis", url: require("../../../assets/icons/logo-cocolis.svg"), size: 24 },
        {
            id: "translated-with-deepl-en",
            url: require("../../../assets/icons/translated_with_DeepL_EN.svg"),
            size: 24
        },
        {
            id: "translated-with-deepl-es",
            url: require("../../../assets/icons/translated_with_DeepL_ES.svg"),
            size: 24
        },
        {
            id: "translated-with-deepl-fr",
            url: require("../../../assets/icons/translated_with_DeepL_FR.svg"),
            size: 24
        },
        {
            id: "translated-with-deepl-it",
            url: require("../../../assets/icons/translated_with_DeepL_IT.svg"),
            size: 24
        },
        { id: "access_time", url: require("../../../assets/icons/ic_access_time.svg"), size: 24 },
        { id: "account_circle", url: require("../../../assets/icons/account-circle.svg"), size: 24 },
        { id: "account-eye", url: require("../../../assets/icons/account-eye.svg"), size: 24 },
        { id: "add", url: require("../../../assets/icons/ic_add.svg"), size: 24 },
        { id: "add_a_photo", url: require("../../../assets/icons/ic_add_a_photo.svg"), size: 24 },
        { id: "add_location", url: require("../../../assets/icons/baseline-add_location-24px.svg"), size: 24 },
        { id: "alarm_add", url: require("../../../assets/icons/baseline-alarm_add-24px.svg"), size: 24 },
        { id: "arrow_back", url: require("../../../assets/icons/ic_arrow_back.svg"), size: 24 },
        { id: "arrow_forward", url: require("../../../assets/icons/ic_arrow_forward.svg"), size: 24 },
        { id: "arrow_downward", url: require("../../../assets/icons/ic_arrow_downward.svg"), size: 24 },
        { id: "arrow_upward", url: require("../../../assets/icons/ic_arrow_upward.svg"), size: 24 },
        { id: "book_open_page", url: require("../../../assets/icons/book-open-page-variant.svg"), size: 24 },
        { id: "brightness_5", url: require("../../../assets/icons/baseline-brightness_5-24px.svg"), size: 24 },
        { id: "calendar_blank", url: require("../../../assets/icons/calendar-blank.svg"), size: 24 },
        { id: "calendar_check", url: require("../../../assets/icons/calendar-check.svg"), size: 24 },
        { id: "calendar_clock", url: require("../../../assets/icons/calendar-clock.svg"), size: 24 },
        { id: "calendar_cross", url: require("../../../assets/icons/calendar-cross.svg"), size: 24 },
        { id: "calendar_question", url: require("../../../assets/icons/calendar-question.svg"), size: 24 },
        { id: "call", url: require("../../../assets/icons/ic_call.svg"), size: 24 },
        { id: "cancel", url: require("../../../assets/icons/ic_cancel.svg"), size: 24 },
        { id: "check", url: require("../../../assets/icons/ic_check.svg"), size: 24 },
        { id: "check_circle", url: require("../../../assets/icons/ic_check_circle.svg"), size: 24 },
        { id: "check-decagram", url: require("../../../assets/icons/check-decagram.svg"), size: 24 },
        { id: "close", url: require("../../../assets/icons/ic_close.svg"), size: 24 },
        { id: "cloud_upload", url: require("../../../assets/icons/ic_cloud_upload.svg"), size: 24 },
        { id: "create", url: require("../../../assets/icons/ic_create.svg"), size: 24 },
        { id: "crop_free", url: require("../../../assets/icons/ic_crop_free.svg"), size: 24 },
        { id: "delete", url: require("../../../assets/icons/ic_delete.svg"), size: 24 },
        { id: "details", url: require("../../../assets/icons/baseline-details-24px.svg"), size: 24 },
        { id: "domain", url: require("../../../assets/icons/domain.svg"), size: 24 },
        { id: "done", url: require("../../../assets/icons/ic_done.svg"), size: 24 },
        { id: "done_all", url: require("../../../assets/icons/ic_done_all.svg"), size: 24 },
        { id: "edit", url: require("../../../assets/icons/ic_edit.svg"), size: 24 },
        { id: "edit_calendar", url: require("../../../assets/icons/edit-calendar.svg"), size: 24 },
        { id: "email", url: require("../../../assets/icons/ic_email.svg"), size: 24 },
        { id: "equalizer", url: require("../../../assets/icons/ic_equalizer.svg"), size: 24 },
        { id: "error", url: require("../../../assets/icons/ic_error.svg"), size: 24 },
        { id: "error_outline", url: require("../../../assets/icons/ic_error_outline.svg"), size: 24 },
        { id: "event", url: require("../../../assets/icons/ic_event.svg"), size: 24 },
        { id: "event_calendar", url: require("../../../assets/icons/event.svg"), size: 24 },
        { id: "exposure", url: require("../../../assets/icons/baseline-exposure-24px.svg"), size: 24 },
        { id: "file_download", url: require("../../../assets/icons/ic_file_download.svg"), size: 24 },
        { id: "file_upload", url: require("../../../assets/icons/ic_file_upload.svg"), size: 24 },
        { id: "filter_b_and_w", url: require("../../../assets/icons/baseline-filter_b_and_w-24px.svg"), size: 24 },
        { id: "filter_list", url: require("../../../assets/icons/ic_filter_list.svg"), size: 24 },
        { id: "gavel", url: require("../../../assets/icons/ic_gavel.svg"), size: 24 },
        { id: "help", url: require("../../../assets/icons/ic_help.svg"), size: 24 },
        { id: "history", url: require("../../../assets/icons/ic_history.svg"), size: 24 },
        { id: "information_outline", url: require("../../../assets/icons/information-outline.svg"), size: 24 },
        { id: "insert_drive_file", url: require("../../../assets/icons/ic_insert_drive_file.svg"), size: 24 },
        { id: "insert_photo", url: require("../../../assets/icons/ic_insert_photo.svg"), size: 24 },
        { id: "info", url: require("../../../assets/icons/ic_info.svg"), size: 24 },
        { id: "keyboard_arrow_down", url: require("../../../assets/icons/ic_keyboard_arrow_down.svg"), size: 24 },
        { id: "keyboard_arrow_left", url: require("../../../assets/icons/ic_keyboard_arrow_left.svg"), size: 24 },
        { id: "keyboard_arrow_right", url: require("../../../assets/icons/ic_keyboard_arrow_right.svg"), size: 24 },
        { id: "keyboard_arrow_up", url: require("../../../assets/icons/ic_keyboard_arrow_up.svg"), size: 24 },
        { id: "link", url: require("../../../assets/icons/link_black_24dp.svg"), size: 24 },
        { id: "list", url: require("../../../assets/icons/ic_list.svg"), size: 24 },
        { id: "local_offer", url: require("../../../assets/icons/ic_local_offer.svg"), size: 24 },
        { id: "location_on", url: require("../../../assets/icons/ic_location_on.svg"), size: 24 },
        { id: "location_off", url: require("../../../assets/icons/ic_location_off.svg"), size: 24 },
        { id: "lock_open", url: require("../../../assets/icons/ic_lock_open.svg"), size: 24 },
        { id: "lock", url: require("../../../assets/icons/lock.svg"), size: 24 },
        { id: "menu", url: require("../../../assets/icons/ic_menu.svg"), size: 24 },
        { id: "merge", url: require("../../../assets/icons/ic_merge.svg"), size: 24 },
        { id: "more_vert", url: require("../../../assets/icons/ic_more_vert.svg"), size: 24 },
        { id: "notifications", url: require("../../../assets/icons/ic_notifications.svg"), size: 24 },
        { id: "open_in_new", url: require("../../../assets/icons/ic_open_in_new.svg"), size: 24 },
        { id: "person", url: require("../../../assets/icons/ic_person.svg"), size: 24 },
        { id: "person_add", url: require("../../../assets/icons/baseline-person_add-24px.svg"), size: 24 },
        { id: "phone", url: require("../../../assets/icons/ic_phone.svg"), size: 24 },
        { id: "photo_library", url: require("../../../assets/icons/ic_photo_library.svg"), size: 24 },
        { id: "picture_as_pdf", url: require("../../../assets/icons/ic_picture_as_pdf.svg"), size: 24 },
        { id: "plus_one", url: require("../../../assets/icons/ic_plus_one.svg"), size: 24 },
        { id: "print", url: require("../../../assets/icons/ic_print.svg"), size: 24 },
        { id: "refresh", url: require("../../../assets/icons/ic_refresh.svg"), size: 24 },
        { id: "remove_circle", url: require("../../../assets/icons/ic_remove_circle.svg"), size: 24 },
        { id: "rotate_left", url: require("../../../assets/icons/ic_rotate_left.svg"), size: 24 },
        { id: "rotate_right", url: require("../../../assets/icons/ic_rotate_right.svg"), size: 24 },
        { id: "save", url: require("../../../assets/icons/ic_save.svg"), size: 24 },
        { id: "search", url: require("../../../assets/icons/ic_search.svg"), size: 24 },
        { id: "sort", url: require("../../../assets/icons/sort.svg"), size: 24 },
        { id: "sort_by_alpha", url: require("../../../assets/icons/ic_sort_by_alpha.svg"), size: 24 },
        { id: "star", url: require("../../../assets/icons/ic_star.svg"), size: 24 },
        { id: "star_border", url: require("../../../assets/icons/ic_star_border.svg"), size: 24 },
        { id: "supervisor_account", url: require("../../../assets/icons/ic_supervisor_account.svg"), size: 24 },
        { id: "tag_multiple", url: require("../../../assets/icons/tag-multiple.svg"), size: 24 },
        { id: "tonality", url: require("../../../assets/icons/baseline-tonality-24px.svg"), size: 24 },
        { id: "undo", url: require("../../../assets/icons/ic_undo.svg"), size: 24 },
        { id: "visibility_off", url: require("../../../assets/icons/ic_visibility_off.svg"), size: 24 },
        { id: "pan_tool", url: require("../../../assets/icons/pan_tool-24px.svg"), size: 24 },
        { id: "video_check", url: require("../../../assets/icons/video-check.svg"), size: 24 },
        { id: "video_plus", url: require("../../../assets/icons/video-plus.svg"), size: 24 },
        { id: "view_module", url: require("../../../assets/icons/ic_view_module.svg"), size: 24 },
        { id: "visibility", url: require("../../../assets/icons/ic_visibility.svg"), size: 24 },
        { id: "visibility_off", url: require("../../../assets/icons/ic_visibility_off.svg"), size: 24 },
        { id: "warning", url: require("../../../assets/icons/ic_warning.svg"), size: 24 },
        { id: "wordpress", url: require("../../../assets/icons/wordpress.svg"), size: 24 },
        { id: "zoom_in", url: require("../../../assets/icons/ic_zoom_in.svg"), size: 24 }
    ])
    .config(IconsSet)
    .run(IconsCache);
